import api from 'apis/config/api-service';

interface Product {
  id?: string | number;
  [key: string]: any;
}

interface ApiParams {
  [key: string]: any;
}

export default {
  getProducts: (supplierId: string | number, params?: ApiParams) =>
    api.get(`products?filter=supplierId||$eq||${supplierId}&filter=status||$notin||merged&`, { ...params }),
  upsertProduct: (product: Product) =>
    product.id ? api.patch(`products/${product.id}`, product) : api.post('catalog/v1/legacy-products', product),
};
